import React from 'react'
import { useHistory } from 'react-router-dom'
import './InterviewQuestions.less'
import { Space, Typography, Anchor } from 'antd'
import Footer from '@/layouts/footer'

const InterviewQuestions = ({ setIndex, questions, setSelcQues }) => {
  const history = useHistory()

  const handleQuestionClick = (question) => {
    setSelcQues(question.question)
    setIndex(2)
  }

  // Create an array of anchor items based on categories
  const anchorItems = questions.category
    .slice()
    .reverse()
    .map((category) => ({
      key: category.category.split(' ')[0],
      href: `#${category.category.split(' ')[0]}`, // Use the first word as the ID
      title: category.category.split(' ')[0] // Use the first word as the anchor title
    }))

  return (
    <>
      <div className="questions-container">
        <h2 style={{ fontWeight: 'bold' }}>Interview Questions</h2>
        <Space direction="vertical" align="center" className="profile-space" style={{ marginBottom: 50 }}>
          <Typography.Text>👆 Click on a question to kickstart your practice! 🚀🎙️</Typography.Text>
        </Space>
        <Anchor
          direction="vertical"
          items={questions.category
            .slice()
            .reverse()
            .map((category) => ({
              key: category.category.split(' ')[0],
              href: `#${category.category.split(' ')[0]}`, // Use the first word as the ID
              title: category.category.split(' ')[0] // Use the first word as the anchor title
            }))}
        />
        {questions.category.slice().map((category, index) => (
          <div key={index} className="questions-list">
            <h3 id={category.category.split(' ')[0]}>{category.category}</h3>
            <ul>
              {questions.question_bank
                .filter((question) => question.category === category.id)
                .map((question, qIndex) => (
                  <li key={qIndex} className="list-item" onClick={() => handleQuestionClick(question)}>
                    {question.question}
                  </li>
                ))}
            </ul>
          </div>
        ))}
      </div>
      <Footer />
    </>
  )
}

export default InterviewQuestions
